import { accessors } from '@yola/subscription-manager-js';

const getEcommerceAutoRenewStatus = () => {
  const ecommerceSubscription = accessors.getActiveEcommerceSubscription();
  return ecommerceSubscription?.auto_renew || false;
};

export default getEcommerceAutoRenewStatus;
